import { render, staticRenderFns } from "./MessagingPage.vue?vue&type=template&id=7649fae1&scoped=true"
import script from "./MessagingPage.vue?vue&type=script&lang=js"
export * from "./MessagingPage.vue?vue&type=script&lang=js"
import style0 from "./MessagingPage.vue?vue&type=style&index=0&id=7649fae1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7649fae1",
  null
  
)

export default component.exports